import React from "react";
import aboutImage from "../../assets/brand/AB.jpg";
import Badge from "../ui/Badge";

const AboutHero: React.FC = () => {
  return (
    <section className="bg-white py-10">
      <div className="layout-container max-w-[1360px] mx-auto px-5">
        <div className="w-full flex flex-col">
          <div className="mb-8 flex flex-col items-start gap-3">
            <Badge className="inline-flex rounded-full bg-white border border-[#B8B8B8] px-3 py-1 font-description text-[10px] font-normal text-[#919191]">
              Bao Technologies
            </Badge>
            <div className="flex flex-col lg:flex-row justify-between items-start gap-6 lg:gap-12 w-full">
              <h1 className="font-title text-[36px] md:text-[46px] font-semibold leading-[1.08] tracking-[-0.02em] text-[#212121] max-[700px]:text-[32px]">
                About Bao Technologies
              </h1>
              <p className="font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191] max-w-[560px]">
                Bao Technologies is a technology company delivering digital
                solutions, products, and transformation support to organizations
                from our base in Bonamoussadi, Douala. We design and build
                custom software, scalable digital products, and strategic
                services that help organizations modernize, grow, and operate
                more efficiently.
                <br />
                <br />
                We don't take every project — we partner with businesses that
                know their goals, are committed to meaningful change, and value
                long-term collaboration over quick fixes. In return, we show up
                fully and stay for the long run.
              </p>
            </div>
          </div>

          <div className="relative w-full rounded-[20px] overflow-hidden min-h-[260px] md:min-h-[340px] flex items-center justify-center">
            <img
              src={aboutImage}
              alt="Bao Technologies Team"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />

            <div className="relative z-10 flex flex-col items-center text-center p-6">
              <h2 className="text-white font-title text-[28px] md:text-[36px] font-medium leading-[1.1]">
                Let's build your digital dream
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
